import AddNewElementButton from '@/components/Common/AddNewElementButton';

// @vue/component
export default {
  name: 'RegenerateAllIvrMessagesForm',

  components: {
    AddNewElementButton,
  },

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      elementsToRegenerate: [],
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/ivrBasicMessages/regenerateSelectedIvrMessages',
      ]);
    },
  },

  methods: {
    async handleRegenerateIvrMessages() {
      const params = {
        project: this.projectUuid,
        elements: this.elementsToRegenerate,
      };
      try {
        const results = await this.$store.dispatch('client/project/ivrBasicMessages/regenerateSelectedIvrMessages', params);
        this.$message({
          type: 'success',
          message: `Poprawnie wygenerowano${results.record.messages_count} komunikatów.`,
        });
      } catch (err) {
        this.$message({
          type: 'error',
          message: 'Nie udało się wygenerować komunikatów.',
        });
      }
      this.$emit('closeModal');
    },
  },
};
